
module.exports = { 
      attributes: {},
    
      body: "Pregnancy, maternity, and newborn services includes antenatal, during pregancy, and postnatal care for women and babies up to six weeks after birth.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/pregnancy-maternity-and-newborn.md"},
     }